import React from 'react'
import '../../styles/_Skills.css'
import { Badge } from 'react-bootstrap'

const LabBadge = ({ skill, src, numberBadge }) => {
  return (
    <li className='listSkill'>
      <p className='color2 skill--name'>{skill}</p>
      <div className='box-badge-coder'>
        <img src={src} alt='coder' className='badge-img' />
        {/* <div className='badge-count'>
            <p className='numberB'>x<strong>{numberBadge}</strong></p>
</div> */}
        <Badge className='numberB'>x {numberBadge}</Badge>
      </div>
    </li>
  )
}

const Professional = ({bio, isSpanish}) => {
  const HabilidadesProf = bio.map((item, index) => {
    return (
      item.professional.map((p, idx) => {
        return <LabBadge
          key={idx}
          skill={p.habilidad}
          src={p.image}
          numberBadge={p.numberBadget}
        />
      })
    )
  })
  const ProfSkills = bio.map((item, index) => {
    return (
      item.professional.map((p, idx) => {
        return <LabBadge
          key={idx}
          skill={p.skill}
          src={p.image}
          numberBadge={p.numberBadget}
        />
      })
    )
  })
  /* const style = {
      margin: '2%',
  } */
  return (
    <div className='section--professional'>
      <h3 className='section-item-title-2'><i className='fa fa-users'></i>&nbsp;&nbsp; {isSpanish === true ? 'Habilidades Profesionales' : 'Professional Skills'}</h3>
      <ul className='listBadgetsComplete'>
        {isSpanish === true ? HabilidadesProf : ProfSkills}
      </ul>
    </div>
  )
}

export default Professional



// WEBPACK FOOTER //
// ./src/components/Skills/Badge.js